import routes from "../../../Utils/routes";
import { useStyles } from "../styles";
import { Accordion, AccordionDetails, AccordionSummary, Box, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import homeactive from "../../../Assets/navicons/active/home.png";
import home from "../../../Assets/navicons/inactive/home.png";
import learn from "../../../Assets/navicons/inactive/learn.png";
import fee from "../../../Assets/navicons/inactive/feepayment.png";
import feeActive from "../../../Assets/navicons/active/fee.png";
import service from "../../../Assets/navicons/inactive/service.png";
import serviceActive from "../../../Assets/navicons/active/service.png";
import exam from "../../../Assets/navicons/inactive/exams.png";
import examActive from "../../../Assets/navicons/active/exams.png";
import grade from "../../../Assets/navicons/inactive/grade.png";
import gradeActive from "../../../Assets/navicons/active/grade.png";
import schedule from "../../../Assets/navicons/inactive/schedule.png";
import scheduleActive from "../../../Assets/navicons/active/schedule.png";
import event from "../../../Assets/navicons/inactive/events.png";
import eventActive from "../../../Assets/navicons/active/events.png"
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import EnrolledCourseIcon from "../../../Assets/CourseEnrollment.svg";
import EnrolledCourseActiveIcon from "../../../Assets/CourseEnrollmentActive.svg";
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ResultsIcon from "../../../Assets/Results.svg";


interface SideNavProps {
  handleListClick: (link: string) => void;
}

interface SideNavTabsProps {
  icon: (isActive: boolean) => JSX.Element;
  label: string;
  link?: string;
  name: string;
  child?: Array<SideNavTabsProps>;
}

interface ITabButtonsProps {
  items: SideNavTabsProps;
  handleListClick: (link: string) => void;
  isActive: boolean;
}

interface ITreeTabButtonsProps {
  isActive: boolean;
  handleActiveTabs: (label: string) => void;
  items: SideNavTabsProps;
  handleListClick: (link: string) => void;
}

export const TabButtons: React.FunctionComponent<ITabButtonsProps> = ({ items, handleListClick, isActive }) => {
  const classes = useStyles();

  return (
    <ListItemButton
      data-testid={`data-${items.name}-${isActive}`}
      onClick={() => {
        handleListClick(`${items.link}`);
      }}
      style={{
        marginTop: "1px",
      }}
      className={`${classes.listItemButton} ${isActive && classes.listItemButtonActive}`}
    >
      <ListItemIcon
        sx={{
          minWidth: { xs: "10px", lg: "30px" },
          "@media (min-width: 1280px) and (max-width: 1300px)": {
            fontSize: "10px",
          },
        }}
      >
        {items.icon(isActive)}
      </ListItemIcon>
      <ListItemText
        className={`${classes.listItemText} ${isActive && classes.listItemTextActive}`}
        sx={{
          display: { xs: "none", sm: "none", md: "none", lg: "block" },
        }}
      >
        {items.label}
      </ListItemText>
    </ListItemButton>
  );
};

export const TreeTabButtons: React.FunctionComponent<ITreeTabButtonsProps> = ({ isActive, handleActiveTabs, items, handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split("/").filter((items: string) => {
    return items && items !== "";
  });

  const isAnyChildActive = (items?.child || []).some((child: any) => {
    if (child.name === "exams" && getFirstPath[0] === "exams" && !getFirstPath[1]) {
      return true;
    }
    if (child.name === "results") {
      return getFirstPath[1] === "results" || getFirstPath[1] === "marks-breakdown" || getFirstPath[1] === "grade-cards-download";
    }
    return getFirstPath[1] === child.name;
  });

  const isParentActive = getFirstPath[0] === items.name || isAnyChildActive;

  return (
    <Accordion
      expanded={isActive}
      onChange={() => {
        handleActiveTabs(items.name);
      }}
      data-testid={`data-${items.name}-${isActive}`}
      className={classes.accordionRoot}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header" className={classes.accordionSummary}>
        <Box component={"div"} className={`${classes.listItemButton} d-flex align-items-center gap-2`}>
          {items.icon(isParentActive)}
          <Typography
            component="span"
            className={`${classes.listItemText} `}
            fontWeight={isParentActive ? "600" : "400"}
            sx={{
              display: { xs: "none", sm: "none", md: "none", lg: "block" },
            }}
          >
            {items.label}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {(items?.child || []).map((items: any, index: number) => {
          let isActive = false;
          if (items.name === "exams" && getFirstPath[0] === "exams" && !getFirstPath[1]) {
            isActive = true;
          } else if (items.name === "results") {
            isActive = getFirstPath[1] === "results" || getFirstPath[1] === "marks-breakdown" || getFirstPath[1] === "grade-cards-download";
          } else {
            isActive = getFirstPath[1] === items.name;
          }
          return <TabButtons items={items} handleListClick={handleListClick} isActive={isActive} key={index} />;
        })}
      </AccordionDetails>
    </Accordion>
  );
};

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split("/").filter((items: string) => {
    return items && items !== "";
  });
  const [activeTab, setActiveTab] = useState<string>("");

  const handleActiveTabs = (label: string) => {
    if (activeTab === label) {
      setActiveTab("");
    } else {
      setActiveTab(label);
    }
  };

  const sideNavContents: any = [
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? homeactive : home} />;
      },
      label: "Home",
      link: routes.home,
      name: "home",
    },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? learn : learn} />;
      },
      label: "Learn",
      link: routes.learn,
      name: "learn",
    },
    // {
    //   icon: (isActive: boolean) => {
    //     return (
    //       <ImportContactsIcon
    //         sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
    //       />
    //     );
    //   },
    //   label: "Program Path",
    //   link: routes.programPathway,
    //   name: "program-path",
    // },
    // {
    //   icon: (isActive: boolean) => {
    //     return <Box component={"img"} className={classes.navIcons} src={isActive ? EnrolledCourseActiveIcon : EnrolledCourseIcon} />;
    //   },
    //   label: "Course Enrollment",
    //   link: routes.courseEnrollment,
    //   name: "course%20enrollment",
    // },
    // {
    //   icon: (isActive: boolean) => {
    //     return <ChecklistOutlinedIcon sx={{ color: isActive ? '#3061FF' : '#A0A0A0', fontSize: 28 }} />;
    //   },
    //   label: "Feedback",
    //   link: "/feedback",
    //   name: "feedback",
    // },
    {
      icon: (isActive: boolean) => {
        return (
          <ImportContactsIcon
            sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
          />
        );
      },
      label: "Program Path",
      link: routes.programPathway,
      name: "program-path",
    },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? EnrolledCourseActiveIcon : EnrolledCourseIcon} />;
      },
      label: "Course Enrollment",
      link: routes.courseEnrollment,
      name: "course%20enrollment",
    },
    // {
    //   icon: (isActive: boolean) => {
    //     return <ChecklistOutlinedIcon sx={{ color: isActive ? '#3061FF' : '#A0A0A0', fontSize: 28 }} />;
    //   },
    //   label: "Feedback",
    //   link: "/feedback",
    //   name: "feedback",
    // },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? feeActive : fee} />;
      },
      label: "Fees",
      link: routes.fees,
      name: "fees",
    },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? examActive : exam} />;
      },
      label: "Examination",
      link: routes.exams,
      name: "exams",
      child: [
        {
          icon: (isActive: boolean) => {
            return (
              <CalendarTodayIcon
                sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
              />
            );
          },
          label: "My Exams",
          link: routes.exams,
          name: "exams",
        },
        {
          icon: (isActive: boolean) => {
            return (
              <CalendarTodayIcon
                sx={{ color: isActive ? '#ffffff' : '#b2b3b7', fontSize: 24 }}
              />
            );
          },
          label: "Take Exams",
          link: routes.takeExams,
          name: "take-exams",
        },
        // Commented out Results tab for now
        {
          icon: (isActive: boolean) => {
            return <Box component={"img"} className={classes.navIcons} src={ResultsIcon} />;
          },
          label: "Results",
          link: routes.gradeCard,
          name: "results",
        },
      ],
    },
    // {
    //   icon: (isActive: boolean) => {
    //     return <Box component={"img"} className={classes.navIcons} src={isActive ? examActive : exam} />;
    //   },
    //   label: "Exams",
    //   link: routes.myProfile,
    //   name: "exams",
    //   child: [
    //     {
    //       icon: (isActive: boolean) => {
    //         return <Box component={"img"} className={classes.navIcons} src={isActive ? gradeActive : grade} />;
    //       },
    //       label: "Grade Card",
    //       link: routes.gradeCard,
    //       name: "grade",
    //     },
    //     {
    //       icon: (isActive: boolean) => {
    //         return <Box component={"img"} className={classes.navIcons} src={isActive ? scheduleActive : schedule} />;
    //       },
    //       label: "Exam Schedule",
    //       link: routes.examSchedule,
    //       name: "schedule",
    //     },
    //   ],
    // },
    // {
    //   icon: (isActive: boolean) => {
    //     return <Box component={"img"} className={classes.navIcons} src={isActive ? eventActive : event} />;
    //   },
    //   label: "Events",
    //   link: routes.events,
    //   name: "events",
    // },
    {
      icon: (isActive: boolean) => {
        return <Box component={"img"} className={classes.navIcons} src={isActive ? serviceActive : service} />;
      },
      label: "Service & Support",
      link: routes.service,
      name: "service%20&%20support",
    },
    {
      icon: (isActive: boolean) => {
        return <LogoutIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Logout",
      link: routes.login,
      name: "logout",
    },
  ];

  useEffect(() => {
    if (!pathname.includes(activeTab)) {
      setActiveTab("");
    }
  }, [pathname]);

  const TabButtons: React.FunctionComponent<any> = ({ items, index, isChild }) => {
    let isActive = false;
    if (isChild) {
      if (items.name === "results") {
        isActive = getFirstPath[1] === "results" || getFirstPath[1] === "marks-breakdown" || getFirstPath[1] === "grade-cards-download";
      } else {
        isActive = getFirstPath[1] === items.name;
      }
    } else {
      isActive = getFirstPath[0] === items.name;
    }
    return (
      <ListItemButton
        onClick={() => {
          handleListClick(items.link);
        }}
        style={{
          marginTop: "1px",
        }}
        className={`${classes.listItemButton} ${isActive && classes.listItemButtonActive}`}
      >
        <ListItemIcon
          sx={{
            minWidth: { xs: "10px", lg: "30px" },
            "@media (min-width: 1280px) and (max-width: 1300px)": {
              fontSize: "10px",
            },
          }}
        >
          {items.icon(isActive)}
        </ListItemIcon>
        <ListItemText
          className={`${classes.listItemText} ${isActive && classes.listItemTextActive}`}
          sx={{
            display: { xs: "none", sm: "none", md: "none", lg: "block" },
          }}
        >
          {items.label}
        </ListItemText>
      </ListItemButton>
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: 0,
      }}
    >
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          minHeight: 0,
          paddingBottom: "10px",
        }}
        className="scrollbar-cusgray"
      >
        {sideNavContents?.slice(0, -1)?.map((items: any, index: number) => {
          const isActive = activeTab === items.name;
          const isNormalActive = getFirstPath[0] === items.name;
          return (items?.child || []).length > 0 ? <TreeTabButtons key={index} handleActiveTabs={handleActiveTabs} handleListClick={handleListClick} isActive={isActive} items={items} /> : <TabButtons items={items} handleListClick={handleListClick} isActive={isNormalActive} key={index} />;
        })}
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          paddingTop: "10px",
          width: "100%",
        }}
      >
        {sideNavContents.slice(-1)?.map((items: any, index: number) => {
          return (
            <ListItemButton
              key={index}
              onClick={() => {
                handleListClick(items.link);
              }}
              sx={{
                marginTop: "0px",
                width: "100%",
              }}
              className={`${classes.listItemButton}`}
            >
              <ListItemIcon sx={{ minWidth: { xs: "10px", lg: "30px" } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
              <ListItemText
                className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                sx={{
                  display: { xs: "none", sm: "none", md: "none", lg: "block" },
                }}
              >
                {items.label}
              </ListItemText>
            </ListItemButton>
          );
        })}
      </Box>
    </Box>
  );
};

export default SideNavTabs;
